module.exports = __webpack_public_path__ + "img/bgBox_sp.753984ef.jpg";